<template lang="pug">

	.user-team.-helvetica-
		Header(:mode="mode")
		Body(:mode="mode")

</template>

<script>
import Header from './components/Header';
import Body from './components/Body';

export default {
  components: {
    Header,
    Body
  },
  data: () => ({
    mode: 'allocated'
  }),
  watch: {
    '$route.meta.mode': function (mode) {
      this.mode = mode;
    }
  },
  created() {
    this.mode = this.$route.meta.mode;
  }
};
</script>
